import { coursesRequested } from '../features/courses/store/coursesListSlice.js';
import { courseDetailRequested } from '../features/courses/store/courseDetailSlice.js';
import { coachingPageRequested } from '../features/coaching/store/coachingSlice.js';
import { libraryRequested, productDetailRequested } from '../features/library/store/librarySlice.js';
import { proficiencyRequested } from '../features/progress/store/progressSlice.js';
import { featureVisibilityRequested } from '../features/appVisibility/store/featureVisibilitySlice.js';

export function getNativeRefreshActions(pathname) {
  const segments = String(pathname || '').split('/').filter(Boolean);
  const [root, id] = segments;

  if (segments.length === 1 && ['courses', 'assessments', 'coaching'].includes(root)) {
    return [coursesRequested(), featureVisibilityRequested()];
  }
  if ((root === 'courses' || root === 'assessments') && id) {
    return [courseDetailRequested(id)];
  }
  if (root === 'coaching' && id) {
    return [coachingPageRequested({ courseId: id })];
  }
  if (root === 'library' && !id) {
    return [libraryRequested()];
  }
  if (root === 'library' && id && Number.isFinite(Number(id))) {
    return [productDetailRequested(Number(id))];
  }
  if (root === 'progress' && !id) {
    return [proficiencyRequested()];
  }

  return [];
}
